import { zodResolver } from '@hookform/resolvers/zod'
import { CheckCircle2 } from 'lucide-react'
import { useCallback, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'

import { Button } from '@/components/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/dialog'
import { SideImageForm } from '@/components/side-image-form'
import {
  registerPreserverFormValidationSchema,
  RegisterPreserverFormValues,
} from '@/schemas/auth-schema'

import { PreserverForm } from './components/preserver-form'

export function RegisterPreserver() {
  const navigate = useNavigate()

  const methods = useForm<RegisterPreserverFormValues>({
    resolver: zodResolver(registerPreserverFormValidationSchema),
    defaultValues: {
      confirmPassword: '',
      documento: '',
      email: '',
      nome: '',
      password: '',
      phone: '',
      tp_cadastro: 'F',
      tp_perfil: 1,
    },
  })

  const [saveRegisterDialog, setSaveRegisterDialog] = useState(false)

  const handleUpdateValueTermsModal = useCallback((value: boolean) => {
    setSaveRegisterDialog(value)
  }, [])

  function handleModalExit() {
    setSaveRegisterDialog(false)
    navigate('/login')
  }

  return (
    <div className="grid flex-1 grid-cols-1 bg-monochromatic-200 lg:grid-cols-9">
      <SideImageForm
        title="Seja um guardião ambiental"
        className="bg-registerPreserver"
      />
      <div className="my-auto px-10 py-5 md:px-20 lg:col-span-4 xl:px-36 xl:pt-6 2xl:px-56 2xl:py-0 2xl:pb-6 2xl:pt-11">
        <h1 className="mb-6 text-center text-3xl font-bold text-bios-title lg:text-start xl:text-4xl 2xl:mb-6 2xl:text-5xl">
          Cadastre-se
        </h1>
        <FormProvider {...methods}>
          <PreserverForm
            handleUpdateValueTermsModal={handleUpdateValueTermsModal}
          />
        </FormProvider>
      </div>

      <Dialog open={saveRegisterDialog} onOpenChange={handleModalExit}>
        <DialogContent className="h-auto max-w-116">
          <DialogHeader>
            <CheckCircle2 className="mx-auto size-24 text-bios-primary" />

            <DialogTitle>Cadastro salvo com sucesso</DialogTitle>

            <DialogDescription>
              Entre no seu e-mail e ative o cadastro para acessar a plataforma
            </DialogDescription>
          </DialogHeader>

          <DialogFooter>
            <Button asChild>
              <Link to="/login">Ok</Link>
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}
